import * as React from 'react';
import { Text, TextTypography } from '../Text';
import { st, classes } from './DropdownOption.st.css';
import { DropdownOptionTextOverflow } from './types';
import { DATA_HOOKS } from './constants';
export const DropdownOption = (props) => {
    const { value, id, isSelectable, subtitle, icon, suffix, isSectionTitle, className, unavailable, indentIcon, textOverflow = DropdownOptionTextOverflow.ellipsis, } = props;
    return (React.createElement("div", { "data-hook": DATA_HOOKS.option, key: id, className: st(classes.root, {
            withIcon: !!icon,
            sectionTitle: isSectionTitle,
            selectable: isSelectable,
            unavailable: !!unavailable,
            indentIcon: !!indentIcon,
            textOverflow,
        }, className) },
        icon && (React.createElement("div", { "data-hook": DATA_HOOKS.icon, className: classes.icon }, icon)),
        React.createElement("div", { className: classes.contentWrapper },
            React.createElement(Text, { className: classes.title, typography: TextTypography.runningText }, value),
            subtitle && (React.createElement(Text, { className: classes.subtitle, typography: TextTypography.runningText }, subtitle))),
        suffix && (React.createElement("div", { "data-hook": DATA_HOOKS.suffix, className: classes.suffix }, suffix))));
};
//# sourceMappingURL=DropdownOption.js.map